import React from "react";

const CameraStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.75,
  y: 4.75,
  width: 10.5,
  height: 10.5,
  rx: 1.25,
  stroke: "currentColor",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1_379_559",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 7.6L17.4855 4.9087C18.152 4.50878 19 4.9889 19 5.76619V14.2338C19 15.0111 18.152 15.4912 17.4855 15.0913L13 12.4V7.6Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13 7.6L12.2283 6.31376L11.5 6.75071V7.6H13ZM13 12.4H11.5V13.2493L12.2283 13.6862L13 12.4ZM13.7717 8.88624L18.2572 6.19494L16.7138 3.62246L12.2283 6.31376L13.7717 8.88624ZM17.5 5.76619V14.2338H20.5V5.76619H17.5ZM18.2572 13.8051L13.7717 11.1138L12.2283 13.6862L16.7138 16.3775L18.2572 13.8051ZM14.5 12.4V7.6H11.5V12.4H14.5ZM17.5 14.2338C17.5 13.8452 17.924 13.6051 18.2572 13.8051L16.7138 16.3775C18.3801 17.3773 20.5 16.177 20.5 14.2338H17.5ZM18.2572 6.19494C17.924 6.39489 17.5 6.15484 17.5 5.76619H20.5C20.5 3.82296 18.3801 2.62267 16.7138 3.62246L18.2572 6.19494Z",
  fill: "currentColor",
  mask: "url(#path-2-inside-1_379_559)"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CameraStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;